import * as angular from 'angular';

/**
 * Dataset link presentation component.
 *
 * This component provides a helper to render a dataset link with a few options.
 * Currently, this component only links to the most recent version of the dataset.
 * It would need additional complexity added to the `ui-sref` to extend this to
 * be able to handle a run token as well.
 */
class DatasetLinkController implements angular.IController {
  // bindings
  queryName: string;
  queryToken: string;
  accountToken: string;
  reportToken: string;
  charLimit: number;
  external = true;

  constructor() {}

  makeShortenString(stringToShorten: string, charLimit: number): string {
    let modifiedString = stringToShorten;
    // If the string is already less than the length of the limit specified (or no limit specified) then simply return
    if ((stringToShorten && stringToShorten.length < charLimit) || charLimit == null) {
      return stringToShorten;
    } else {
      modifiedString = modifiedString.substring(0, charLimit - 3);
      return `${modifiedString}...`;
    }
  }
}

export const DatasetLinkComponent: angular.IComponentOptions = {
  bindings: {
    queryName: '<',
    queryToken: '<',
    reportToken: '<',
    accountToken: '<',
    charLimit: '<?',
    external: '<?',
  },
  controller: DatasetLinkController,
  controllerAs: 'ctrl',
  template: `
  <a class="dataset-link"
    ui-sref="reportShow.noRuns.detailsView.detailsDataset({ queryId: ctrl.queryToken, account: ctrl.accountToken, reportId: ctrl.reportToken })"
    ng-attr-target="{{(ctrl.external) ? '_blank' : undefined}}"
    rel="noreferrer"
    title="{{ ctrl.queryName }}">
    {{ ctrl.makeShortenString(ctrl.queryName, ctrl.charLimit) }}
    <i ng-if="ctrl.external" class="icon-external-link"></i>
  </a>
  `,
};
